export default __webpack_public_path__ + "static/media/DNo.23-2.13a37dd0.jpg";